<template>
  <v-app class="applications">
    <v-app-bar v-if="$route.name !== 'Signup'" app dark color="primary">
      <v-avatar v-if="company.base64Logo">
        <v-img
          alt="Logo"
          :src="`data:image/png;base64,${company.base64Logo}`"
          width="100%"
          @click="$router.push({ name: 'Landing' })"
        />
      </v-avatar>
      <v-btn v-else text @click="$router.push({ name: 'Landing' })">
        {{ company.displayName }}
      </v-btn>
      <div class="text-lg-h6 mx-2">Student Applications</div>
      <v-spacer />
      <v-btn text v-if="auth.check()" @click="$store.dispatch('Auth/logout')">
        <v-icon class="mx-2">mdi-power</v-icon>
        Logout
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container v-if="$route.name !== 'Signup'" class="mt-5">
        <v-card v-if="auth.check()" class="mx-auto">
          <v-card-text v-show="show">
            <v-row>
              <v-col cols="12" md="2" lg="2">
                <v-sheet
                  class="overline px-3 d-flex flex-column text-center align-items-center"
                >
                  <h1 class="programme primary--text">
                    {{ application.programme }}
                  </h1>
                  <p class="programme">Programme</p>
                </v-sheet>
              </v-col>
              <v-col v-if="$vuetify.breakpoint.smAndDown" cols="12">
                <v-divider />
              </v-col>
              <v-col cols="12" md="10" lg="10">
                <v-row>
                  <v-col cols="12" md="4" lg="4">
                    <v-sheet
                      class="overline px-3 d-flex flex-column text-center align-items-center"
                    >
                      <h3 class="programme primary--text">
                        {{ application["applicationID"] }}
                      </h3>
                      <p class="programme text-uppercase">Application ID</p>
                    </v-sheet>
                  </v-col>
                  <v-col cols="12" md="4" lg="4">
                    <v-sheet
                      class="overline px-3 d-flex flex-column text-center align-items-center"
                    >
                      <h3
                        class="font-weight-bold programme primary--text"
                        v-if="application"
                      >
                        {{ dateFormat(application["applicationDate"]) }}
                      </h3>
                      <p class="programme text-uppercase">Application Date</p>
                    </v-sheet>
                  </v-col>
                  <v-col cols="12" md="4" lg="4">
                    <v-sheet
                      class="overline px-3 d-flex flex-column text-center align-items-center"
                    >
                      <h3 class="font-weight-bold programme primary--text">
                        {{ user.profile.identificationDocumentNo }}
                      </h3>
                      <p class="programme text-uppercase">National ID</p>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <router-view />
    </v-main>

    <spinner />
    <!--    <FooterComponent opacity="0.65" />-->
    <OtpVerification />
    <Confirmation />
  </v-app>
</template>

<script>
// import FooterComponent from "../../dashboard/components/FooterComponent";
import Spinner from "../../dashboard/plugins/loader/views/Spinner";
import { AuthService } from "../../dashboard/modules/auth";
import OtpVerification from "../../dashboard/plugins/verify/OtpVerification.vue";
import Confirmation from "../../dashboard/plugins/confirmtion/ConfirmationComponent.vue";
import helpers from "../../dashboard/utils/helpers/helper.js";

export default {
  name: "ApplicationsComponent",
  components: {
    Spinner,
    // FooterComponent,
    OtpVerification,
    Confirmation,
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Application/getSetupProgrammes");
      v.$store.dispatch("Landing/getCompanyInfo");
      if (v.auth.check()) {
        v.$store.dispatch(
          "Application/getApplications",
          v.user.profile.profileID,
        );
        v.$store.dispatch("Profile/getAllSetup");
        v.$store.dispatch("Profile/getProfile");
      }
      window.document.title = "KISEB::Student Application";
    });
  },
  data: function () {
    return {
      menu: false,
      show: true,
    };
  },
  computed: {
    auth() {
      return AuthService;
    },
    programme() {
      return this.$store.getters["Renewal/setupProgrammes"].filter(
        (item) => item.code === atob(this.$route.params.programme),
      )[0];
    },
    user() {
      return AuthService.user;
    },
    company() {
      return this.$store.getters["Landing/company"];
    },
    application() {
      return this.$store.getters["Application/appGetters"]("application");
    },
  },
  methods: {
    dateFormat: function (date) {
      return helpers.getDateFormat(date);
    },
    localProgramme() {
      return localStorage.programmeCode;
    },
  },
};
</script>

<style>
.app--chip.v-chip {
  width: 26.5ch;
}
.programme {
  font-family: "PT Sans Caption", sans-serif;
  text-align: center;
}
</style>
